import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { KeyboardArrowDown as ArrowDownIcon } from '@mui/icons-material';
import { theme, commonStyles } from '../../styles/theme';

const networks = [
  {
    id: 'solana',
    name: 'Solana',
    icon: '◎',
    logo: 'https://bpzpmhytoyurlgptrpmm.supabase.co/storage/v1/object/public/system-assets/logos/solana.jpg',
    color: '#14F195'
  },
  {
    id: 'ethereum',
    name: 'Ethereum',
    icon: 'Ξ',
    logo: 'https://bpzpmhytoyurlgptrpmm.supabase.co/storage/v1/object/public/system-assets/logos/ethereum.webp',
    color: '#627EEA'
  },
  {
    id: 'abstract',
    name: 'Abstract',
    icon: 'A',
    logo: 'https://bpzpmhytoyurlgptrpmm.supabase.co/storage/v1/object/public/system-assets/logos/abstract.png',
    color: '#FF6B00'
  }
];

const NetworkSelector = ({ selectedNetwork, onNetworkChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  
  const currentNetwork = networks.find(n => n.id === selectedNetwork) || networks[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (network) => {
    onNetworkChange(network.id);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        endIcon={<ArrowDownIcon />}
        sx={{
          borderRadius: 2,
          px: 2,
          py: 1,
          borderColor: `${currentNetwork.color}50`,
          color: currentNetwork.color,
          '&:hover': {
            borderColor: currentNetwork.color,
            bgcolor: `${currentNetwork.color}10`,
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: `${currentNetwork.color}20`,
          }}>
            <img 
              src={currentNetwork.logo} 
              alt={currentNetwork.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = `<span style="font-size: 14px; font-weight: bold; color: ${currentNetwork.color}">${currentNetwork.icon}</span>`;
              }}
            />
          </Box>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {currentNetwork.name}
          </Typography>
        </Box>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            bgcolor: 'rgba(0, 0, 0, 0.95)',
            border: `1px solid ${theme.colors.borderPrimary}`,
            minWidth: 200
          }
        }}
      >
        {networks.map((network) => (
          <MenuItem
            key={network.id}
            onClick={() => handleSelect(network)}
            selected={network.id === selectedNetwork}
            sx={{
              '&.Mui-selected': {
                bgcolor: `${network.color}20`,
              },
              '&:hover': {
                bgcolor: `${network.color}10`,
              }
            }}
          >
            <ListItemIcon>
              <Box sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                overflow: 'hidden',
                bgcolor: `${network.color}20`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <img 
                  src={network.logo} 
                  alt={network.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<span style="font-size: 16px; font-weight: bold; color: ${network.color}">${network.icon}</span>`;
                  }}
                />
              </Box>
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ color: network.color, fontWeight: 'bold' }}>
                {network.name}
              </Typography>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default NetworkSelector;
